import AdrConstants from './adrConstants.js';

let AdrOptions = function(initOptions) {
    let options = {};

    this.set = function(name, value) {
        options[name] = value;
    };

    this.get = function(name) {
        return options[name];
    };

    this.getOptions = function() {
        return options;
    };

    function initData(adrOptions) {
        if (initOptions.type) {
            adrOptions.set(AdrConstants.TYPE, initOptions.type);
        } else if (initOptions.country) {
            if ("HK" === initOptions.country) {
                adrOptions.set(AdrConstants.TYPE, AdrConstants.ADR_HK);
            } else if ("BN, ID, MY, SG".indexOf(initOptions.country) >= 0) {
                // SEA
                // Not getting from nuskin.configuration because
                //  it may not be set yet.
                adrOptions.set(AdrConstants.TYPE, AdrConstants.ADR_SEA);
            } else if ("PH,TH".indexOf(initOptions.country) >= 0) {
                adrOptions.set(AdrConstants.TYPE, AdrConstants.ADR_PHTH)
            } else {
                adrOptions.set(AdrConstants.TYPE, AdrConstants.ADR_NORMAL);
            }
        }
        adrOptions.set(AdrConstants.COUNTRY, initOptions.country);
        adrOptions.set(AdrConstants.LANG, initOptions.language);
        adrOptions.set(AdrConstants.QUALIFIER, initOptions.qualifier);
    }

    initData(this);
};

export default AdrOptions;